module.exports = __webpack_public_path__ + "img/1090666976.3ce049bd.jpg";